import React from "react"

export interface CookieConsentProps {
  locale: string
}

export const CookieConsent: React.FC<CookieConsentProps> = ({ locale = "en" }) => (
  <script src={`https://cdn.gravito.net/hmdcmp/hmdConnect-${locale}-1.0.0-min.js`} async defer />
)

export default CookieConsent
